<template>
  <div>
    <div class="card-form container" id="print">
      <div class="mb-5 w-100 d-flex justify-content-between">
        <div>
          <img
            alt="Logo"
            :src="layoutConfig('self.logo.secundary')"
            class="max-h-40px"
          />
        </div>
        <div class="mt-4">
          <span>Impressão - <label>{{ title }}</label></span>
          <br />
        </div>
      </div>

      <div class="col-12">
        <b-card title="" tag="article" class="mb-2 border border-primary">
          <b-card-text>
            <b-table
              v-if="data.length > 0"
              striped
              small
              hover
              responsive="sm"
              :fields="cleanLabels"
              :items="tableItems"
            >
              <!-- Descrição com histórico embaixo (mesma célula) -->
              <template v-slot:cell(descricao)="data">
                <div v-if="data.item.isSaldoAnterior"></div>
                <div v-else>
                  <div>{{ data.item.descricao }}</div>
                  <div v-if="getHistorico(data.item)" class="text-muted small mt-1">
                    {{ getHistorico(data.item) }}
                  </div>
                </div>
              </template>

              <!-- Valor: tudo à direita, inclusive 'Saldo em ... — valor' -->
              <template v-slot:cell(valor_movimento)="data">
                <div v-if="data.item.isSaldoAnterior" class="font-weight-bold text-right">
                  Saldo em {{ formatDate(data.item.data_saldo_dia_anterior) }} — {{ numberToReal(data.item.valor_movimento) }}
                </div>
                <div v-else class="text-right">
                  <span :style="{ color: data.item.tipo_movimento === 1 ? 'green' : 'red' }">
                    {{ numberToReal(data.item.valor_movimento) }}
                  </span>
                </div>
              </template>

              <!-- Data do movimento -->
              <template v-slot:cell(data_movimento)="data">
                <div v-if="data.item.isSaldoAnterior"></div>
                <div v-else>
                  {{ formatDate(data.item.data_movimento) }}
                </div>
              </template>
            </b-table>
          </b-card-text>
        </b-card>
      </div>

      <div class="mt-5 w-100 d-flex justify-content-end">
        <img
          alt="Logo"
          :src="layoutConfig('self.logo.icone')"
          class="max-h-30px mr-5"
        />
      </div>
    </div>

    <div class="mt-5 w-100 d-flex justify-content-center d-print-none">
      <button
        @click="printDocument"
        class="btn btn-success btn-hover-primary mr-2"
      >
        Imprimir
      </button>
      <button
        @click="$router.go(-1)"
        class="btn btn-success btn-hover-primary mr-2"
      >
        Voltar
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";

export default {
  name: "app-visualizacao-banco",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: { mask },
  components: {},
  data() {
    return {
      allStatus: [],
      data: [],
      labels: [],
      title: null,
    };
  },
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),

    tableItems() {
      const movimentacoes = this.data;
      const tableData = [];
      let lastDate = null;
      let saldoTotal = 0;

      movimentacoes.forEach((mov, index) => {
        const valorMov = Number(mov.valor_movimento) || 0;

        if (lastDate !== mov.data_movimento) {
          if (index === 0) {
            saldoTotal = Number(mov.saldo_dia_anterior) || 0;
          }
          tableData.push({
            descricao: "",
            valor_movimento: saldoTotal,
            data_movimento: "",
            tipo_movimento: null,
            data_saldo_dia_anterior: mov.data_saldo_dia_anterior,
            isSaldoAnterior: true,
          });
        }

        tableData.push({
          ...mov,
          saldo_dia_anterior: null,
          data_saldo_dia_anterior: null,
        });

        saldoTotal += mov.tipo_movimento === 1 ? valorMov : -valorMov;
        lastDate = mov.data_movimento;
      });

      if (movimentacoes.length > 0) {
        const lastMov = movimentacoes[movimentacoes.length - 1];
        tableData.push({
          descricao: "Saldo Final",
          valor_movimento: saldoTotal,
          data_movimento: "",
          tipo_movimento: null,
          data_saldo_dia_anterior: lastMov.data_movimento,
          isSaldoAnterior: true,
        });
      }

      return tableData;
    },

    // Alinha cabeçalho e células da coluna de valores à direita
    cleanLabels() {
      const base = this.labels
        .filter((l) => l.key !== "acoes")
        .map((f) => ({ ...f }));
      const iValor = base.findIndex((l) => l.key === "valor_movimento");
      if (iValor >= 0) {
        base[iValor].tdClass = (base[iValor].tdClass ? base[iValor].tdClass + " " : "") + "text-right";
        base[iValor].thClass = (base[iValor].thClass ? base[iValor].thClass + " " : "") + "text-right";
      }
      return base;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getInit() {
      this.data = this.$route.params.data;
      this.labels = this.$route.params.labels;
      this.title = this.$route.params.title;
    },
    printDocument() {
      window.print();
    },
    // Histórico baseado no tipo (1 = Entrada, 2 = Saída)
    getHistorico(item) {
      if (item.isSaldoAnterior) return "";
      if (item.tipo_movimento === 1) return item.historico_conta_receber || "";
      if (item.tipo_movimento === 2) return item.historico_conta_pagar || "";
      return "";
    },
  },
  async mounted() {
    await this.getInit();
  },
};
</script>

<style scoped>
svg {
  outline-width: 0;
  outline-color: transparent;
  color: rgb(241, 249, 255);
}

.container {
  background-color: white;
  margin-top: 20px;
  border-radius: 10px;
  padding: 3rem;
  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.05);
  min-width: 100%;
}

.select-city .vs__search::placeholder,
.select-city .vs__dropdown-toggle,
.select-city .vs__dropdown-menu {
  height: 10rem !important;
  background-color: green !important;
}

.contato-input {
  height: 3rem;
}
</style>
